import { useState } from 'react';
import { AppEventsEnum } from '../../shared/enums/AppEventsEnum';
import useElectronListener from './useElectronListener';

const useInnerViewReadyForZoom = () => {
  const [isReady, setIsReady] = useState(false);

  const handleInnerViewReadyForZoom = () => {
    setIsReady(true);
  };

  useElectronListener(
    AppEventsEnum.MAIN_TO_RENDERER_INNER_VIEW_READY_FOR_ZOOM,
    handleInnerViewReadyForZoom
  );

  return {
    isReady,
  };
};

export default useInnerViewReadyForZoom;
